export default {
    name: "GetData",
    title: "GetData",
    icon: "mdi-database-search",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            table: null,
            filters: [],
            output: "field",
            childAction1: [],
            childAction2: []
        };
    },
};